import React from 'react';

export const FullscreenExitSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            d="M20.707 3.293a1 1 0 0 0-1.414 0l-3.536 3.535c-.481.482-.963 1.128-1.389 1.77h-.203a1 1 0 0 1 .029-.182c.227-.93.439-2.033.442-2.93v-.779a1 1 0 0 0-2-.009v5.666a1 1 0 0 0 1 1h5.657a1 1 0 0 0 .004-2h-.762c-.9 0-2.014.213-2.95.442a1 1 0 0 1-.183.029v-.203c.642-.426 1.288-.908 1.77-1.39l3.535-3.535a1 1 0 0 0 0-1.414M3.293 20.707a1 1 0 0 0 1.414 0l3.536-3.535c.481-.482.963-1.128 1.389-1.77h.203a1 1 0 0 1-.029.182c-.227.93-.439 2.033-.442 2.93v.779a1 1 0 0 0 2 .009v-5.666a1 1 0 0 0-1-1H4.707a1 1 0 0 0-.004 2h.761c.902 0 2.014-.213 2.952-.442a1 1 0 0 1 .182-.029v.203c-.642.426-1.288.908-1.77 1.39l-3.535 3.535a1 1 0 0 0 0 1.414"
        />
    </svg>
);
